<div class="full-height layout-column overflow-x-auto-only">

  <app-dashboard-agents-route-score-table class="flex"
                                          [agentsRouteScore]="data"
                                          (fetchNextEvent)="fetchNextEvent.emit()">
  </app-dashboard-agents-route-score-table>

  <loader [isDisplayLoader]="isLoadingData"></loader>

</div>


